import { render, staticRenderFns } from "./winnerRg.vue?vue&type=template&id=49fd4a9c&scoped=true&"
import script from "./winnerRg.vue?vue&type=script&lang=js&"
export * from "./winnerRg.vue?vue&type=script&lang=js&"
import style0 from "./winnerRg.vue?vue&type=style&index=0&id=49fd4a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd4a9c",
  null
  
)

export default component.exports